
function makeAppConfig() {
    let date = new Date();
    let year = date.getFullYear();
    
    let AppConfig = {
        brand: 'KitchenAid EMEA Partner Registration Portal',
        // URL: 'https://backendservice-dot-kitchenaid-esrp-qa.appspot.com',
        // apiKey: 'AIzaSyC2OQ7w9DOnvTUZS-zkvPGQi-5_Prh3Y24',
        // google_client_id: '739276704636-f4agu43bvjt9cumvlfjdfv0304jrb2ct.apps.googleusercontent.com',

        URL: 'https://backendservice-dot-kitchenaid-esrp-prod.appspot.com',
        apiKey: 'AIzaSyB8W1tfuR4KSZ-M3zeY6uy2v741WRGi7g0',
        google_client_id: '968037516609-2uiehuinok2kj4gvudn1j1tlgnk2irmt.apps.googleusercontent.com',

        validNameRegex: /^[a-zA-Z0-9`$%&*_+-:,. ']+$/,
        toasterDefaultTimeOut: 2000,
        toasterDefaultPositionClass: 'toast-bottom-right',      // 'toast-top-full-width', 'toast-bottom-full-width', 'toast-center',
                                                                // 'toast-top-left', 'toast-top-center', 'toast-top-right',
                                                                // 'toast-bottom-left', 'toast-bottom-center', 'toast-bottom-right',
        toastrType: {error:'error', info:'info', wait:'wait', success:'success', warning:'warning'},
        emailPattern: /^.+@.+\..+$/,
        user: '',
        year: year,
        layoutBoxed: false,                             // true, false
        navCollapsed: true,                            // true, false
        navBehind: false,                               // true, false
        fixedHeader: true,                              // true, false
        sidebarWidth: 'middle',                         // small, middle, large      
        theme: 'light',                                 // light, gray, dark
        colorOption: '21',                              // 11,12,13,14,15,16; 21,22,23,24,25,26; 31,32,33,34,35,36
        AutoCloseMobileNav: true,                       // true, false. Automatically close sidenav on route change (Mobile only)
        productLink: '',
        systemAdmin:'SYSTEM_ADMIN',
        regionalAdmin:'REGIONAL_ADMIN',
        BUManager: 'BU_MANAGER',
        applicationManager: 'APPLICATION_MANAGER',
        serviceOwner:'SERVICE_OWNER',
        tradePartner:'TRADE_PARTNER',
        subuser:'SUBUSER'
    };

    return AppConfig;
}

export const APPCONFIG = makeAppConfig();


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/config.ts